import colors from "../../../../Theme/colors";

const style: any = (): any => ({
    button: {
        backgroundColor: "#4285F4 !important",
        height: 50,
        width: 250,
        borderRadius: 5,
        color: `${colors.WHITE} !important`,
        fontSize: "1rem !important",
        marginBottom: "20px",
        "& > div": {
            padding: "0px !important",
            marginLeft:"-28px",
            width: 50,
            height: "100%",
            paddingTop: "16px !important",
            borderRadius: "0px !important",
        },
        "& > span": {
            fontWeight: "bold !important"
        },
    },
    successIconDiv : {
        paddingLeft: "24px", 
        marginTop: "10px"
    },
    googleContainer : {
        display: "flex", 
        flexWrap: "nowrap" 
    },
    buttonNew : {
        backgroundColor: "rgb(255, 255, 255)",
        display: "inline-flex",
        alignItems: "center",
        color: "rgba(0, 0, 0, 0.54)",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 2px 2px 0px, rgba(0, 0, 0, 0.24) 0px 0px 1px 0px",
        padding: "0px",
        borderRadius: "2px",
        border: "1px solid transparent",
        fontSize: "14px",
        fontWeight: "500",
        fontFamily: "Roboto, sans-serif"
    },
    buttonInner : {
        marginRight: "10px",
        background: "rgb(255, 255, 255)",
        padding: "10px", 
        borderRadius: "2px"
    },
    buttonLabel:{
         padding: "10px 10px 10px 0px", 
         fontWeight: "500"
    }
});

export default style;
